import { animate, group, state, style, transition, trigger } from '@angular/animations';
import { ChangeDetectorRef, Component, ElementRef, NgZone, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';

import { Lightbox, LightboxConfig } from 'ngx-lightbox';
import {BehaviorSubject, Observable, timer} from 'rxjs';
import * as uuid from 'uuid';
import { AuthService } from '../auth.service';
import { VcFilterComponent } from '../dialogs/vc-filter/vc-filter.component';
import { Inspection } from '../models/inspection';
import { InspectionMessage } from '../models/inspectionMessage';
import { Tenant } from '../models/tenant';
import { User } from '../models/user';
import _moment from 'moment';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { default as _rollupMoment } from 'moment';
import { NgxGalleryAnimation, NgxGalleryOptions } from 'ngx-gallery-9';
import { NgxSpinnerService } from 'ngx-spinner';
import { VcDeleteConfirmationComponent } from '../dialogs/vc-delete-confirmation/vc-delete-confirmation.component';
import { MultiPolygon } from '../models/multiPolygon';
import { NavBarComponent } from '../nav-bar/nav-bar.component';

import {FormControl, FormGroup} from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import { FarmManagementService } from '../services/farm-management.service';
import { MappingService } from '../services/mapping.service';
import { Base } from '../services/base';
import { ref as storageRef, Storage, uploadBytes, getDownloadURL } from '@angular/fire/storage';
import { Database, listVal, push, ref, remove, serverTimestamp, set } from '@angular/fire/database';
import { environment } from "src/environments/environment";

const moment = _rollupMoment || _moment;
declare var MediaRecorder: any;


@Component({
    selector: 'app-virtual-consultant',
    templateUrl: './virtual-consultant.component.html',
    styleUrls: ['./virtual-consultant.component.css'],
    encapsulation: ViewEncapsulation.None,
    animations: [
        trigger('slideInOut', [
            state('in', style({ opacity: '1', flex: '1 1 100%' }), { params: { inWidth: '250px' } }),
            state('out', style({ width: '15px', opacity: '1', flex: '1 1 1%' })),
            transition('in => out', [group([
                    animate('100ms ease-in-out', style({
                        opacity: '1'
                    })),
                    animate('100ms ease-in-out', style({
                        width: '{{ inWidth }}px'
                    })),
                    animate('100ms ease-in-out', style({
                        flex: '1 1 100%'
                    }))
                ])]),
            transition('out => in', [
                animate('100ms ease-in-out', style({
                    opacity: '1'
                })),
                animate('100ms ease-in-out', style({
                    width: '15px'
                })),
                animate('100ms ease-in-out', style({
                    flex: '1 1 1%'
                }))
            ])
        ]),
        trigger('rotate', [
            state('in', style({ transform: 'rotate(0deg)' })),
            state('out', style({ transform: 'rotate(180deg)' })),
            transition('in => out', [
                animate('600ms ease-in-out', style({
                    transform: 'rotate(0deg)'
                }))
            ]),
            transition('out => in', [
                animate('600ms ease-in-out', style({
                    transform: 'rotate(180deg)'
                }))
            ])
        ])
    ],
    standalone: false
})
export class VirtualConsultantComponent implements OnInit {

    @ViewChild('scrollDiv') private scrollDiv: ElementRef;

    messageForm = new FormGroup({
        message: new FormControl('')
    });

    public allInspections: Observable<Inspection[]>;
    public inspections: Inspection[] = [];
    public filteredInspections: Inspection[];
    public allInspectionMessages: Observable<InspectionMessage[]>;
    private inspectionMessagesCache = new Map<string, Observable<InspectionMessage[]>>();
    public inspectionMessages: InspectionMessage[][] = [];
    public oldInspectionMessages: InspectionMessage[][] = [];
    selectedInspection: any;

    public tenantIdSubject = new BehaviorSubject<number>(null);
    tenantId$ = this.tenantIdSubject.asObservable();

    public mediaPermission = new BehaviorSubject<boolean>(false);
    mediaPermission$ = this.mediaPermission.asObservable();

    mediaRecorder: any;
    chunks = [];

    user: User;

    activeKey = '';


    public environment = environment;

    public tenants: Tenant[] = [];
    public tenantId;
    public fieldName;

    public album: any[] = [];
    public lightboxAlbum: any[] = [];

    imageMap = new Map<number, number>();

    public imageIndex = 0;
    public firstLoad = true;

    shouldScroll = true;

    downloadURL: Observable<string>;

    animationState = 'in';

    inspectionWidth: number;

    farmField = 'Farm/Field not found';

    fieldNotFound = true;
    fieldId = -1;
    farmId = -1;
    farmName = '';


    lat;
    lng;
    description;

    private filterTenants: [] = [];
    startDate;
    endDate;

    galleryOptions: NgxGalleryOptions[];
    showInspections = true;

    polygons = [];
    fieldPolygons = [];

    navigateField: boolean;
    inspectionKey;
    discription;

    inspectionWorker;
    polygonCoords = [];
    unsortedPolygons = [];

    recording = false;
    buttonRecordingActive = false;
    allowMic = false;

    constructor(
        private router: Router,
        private db: Database,
        public auth: AuthService,
        public dialog: MatDialog,
        private _lightbox: Lightbox,
        private _lightboxConfig: LightboxConfig,
        private cdr: ChangeDetectorRef,
        public base: Base,
        public farmManagementService: FarmManagementService,
        public mappingService: MappingService,
        public nav: NavBarComponent,
        public fieldComp: NavBarComponent,
        public translate: TranslateService,
        private spinner: NgxSpinnerService,
        public _snackBar: MatSnackBar,
        public openRecorderSnackBar: MatSnackBar,
        public projectTitle: Title,
        private storage: Storage,
        private ngZone: NgZone
    ) {
        var navigator: any;
        this.nav.toggleLoading(false);

        if (typeof Worker !== 'undefined') {
            this.inspectionWorker = new Worker(new URL('../web-workers/retrieve-inspections.worker', import.meta.url), { type: 'module' });
            this.inspectionWorker.onmessage = ({ data }) => {
                this.messages(JSON.parse(data));
            };
        } else {
            // //
        }

        this.allInspections = listVal(ref(this.db, 'inspections'));

        this.base.fetchVcFilter().subscribe(vcFilter => {
            if (vcFilter.vcFilter != null) {
                this.startDate = vcFilter.vcFilter.startDate;
                this.endDate = vcFilter.vcFilter.endDate;
                this.filterTenants = vcFilter.vcFilter.tenants;
                this.applyFilter();
            }
        });

        if (sessionStorage.getItem('tenants') != null) {
            this.tenants = JSON.parse(sessionStorage.getItem('tenants'));
            this.subscribeToInspections();
        } else {
            this.auth.tenants$.subscribe(tenants => {
                if (tenants != null) {
                    this.tenants = tenants;
                    this.subscribeToInspections();
                }
            });
        }

        if (sessionStorage.getItem('user') != null) {
            this.user = JSON.parse(sessionStorage.getItem('user'));
        } else {
            this.auth.user$.subscribe((user) => {
                if (user != null) {
                    this.user = user;
                }
            });
        }

        if (history.state.navigateField != null || history.state.lat != null) {
            this.navigateField = history.state.navigateField;
            if (this.navigateField) {
                this.loadInspectionMessages(history.state.inspectionKey, history.state.lat, history.state.lng, history.state.tenantId, history.state.description, 0);
            } else {
                this.lat = history.state.lat;
                this.lng = history.state.lng;
                this.subscribeToInspections();
            }
        }

        this.farmField = this.translate.instant('VIRTUAL-CONSULTANT.NOT-FOUND');
    }


    subscribeToInspections() {
         this.nav.toggleLoading(true);
        if (this.lat != null && this.lng != null) {
            this.allInspections.subscribe(inspections => {
                this.inspections = [];

                const sortedInspections = inspections.sort((a, b) => {
                    return a.lastUpdated - b.lastUpdated;
                });
                sortedInspections.reverse();
                this.loadInspections(sortedInspections);

                inspections.forEach(inspection => {
                    if (inspection.latitude == this.lat && inspection.longitude == this.lng) {
                        this.description = inspection.description;
                        this.loadInspectionMessages(inspection.key, this.lat, this.lng, inspection.tenantId, inspection.description, 0);
                    }
                });
            });
        } else {
            this.allInspections.subscribe(inspections => {
                this.inspections = [];
                const sortedInspections = inspections.sort((a, b) => {
                    return a.lastUpdated - b.lastUpdated;
                });
                sortedInspections.reverse();
                this.loadInspections(sortedInspections);
            });
        }
        this.nav.toggleLoading(false);
    }

    loadInspections(inspections: Inspection[]) {
        this.nav.toggleLoading(true);
        
        inspections.forEach(inspection => {
            // Skip database call that causes injection issues
            if(inspection?.key) {
                inspection.unreadMessages = 0;
                if (this.tenants != null) {
                    const isBetween = true;
                    if ((this.startDate != '' && this.startDate != null) || (this.endDate != '' && this.endDate != null)) {
                        const isBetween = Boolean(moment(inspection.lastUpdated).isBetween(this.startDate, this.endDate));
                    }
                    if (this.filterTenants.length != 0) {
                        this.filterTenants.forEach(tenant => {
                            // @ts-ignore
                            if (tenant.isChecked && isBetween) {
                                // @ts-ignore
                                if (tenant.id == Number(inspection.tenantId)) {
                                    const lastUpdated = this.getDay(inspection.lastUpdated);
                                    // @ts-ignore
                                    inspection.tenantName = tenant.name;
                                    inspection.lastUpdated = lastUpdated;
                                    this.inspections.push(inspection);
                                }
                            }
                        });
                    } else {
                        this.tenants.forEach(tenant => {
                            if (tenant.id == Number(inspection.tenantId)) {
                                const lastUpdated = this.getDay(inspection.lastUpdated);
                                inspection.tenantName = tenant.name;
                                inspection.lastUpdated = lastUpdated;
                                this.inspections.push(inspection);

                            }
                        });
                    }
                }
            }
            
        });
        
        this.filteredInspections = this.inspections;
        this.nav.toggleLoading(false);
    }

    loadInspectionMessages(key: string, lat, lng, tenantId, description, unreadCount) {
        this.spinner.show();
        //  this.nav.toggleLoading(false);
        this.inspectionKey = key;
        this.discription = description;
        this.mappingService.getFieldByLatLng(lat, lng, tenantId).subscribe(field => {
            if (!this.isEmpty(field)) {
                this.mappingService.getFarmById(field.farmId).subscribe(farm => {
                    if (!this.isEmpty(farm)) {
                        this.tenantId = tenantId;
                        this.farmField = farm.name + ' | ' + field.name;
                        this.fieldName = field.name;
                        this.fieldNotFound = false;
                        this.fieldId = field.id;
                        this.farmId = farm.id;
                        this.farmName = farm.name;
                        this.lat = lat;
                        this.lng = lng;
                        this.description = description;
                    }
                });
            } else {
                this.translate.get('VIRTUAL-CONSULTANT.NOT-FOUND').subscribe(res => {
                    this.farmField = res;
                });
                this.fieldNotFound = true;
            }
        });
        this.removeUnreadCount(key);
        this.activeKey = key;
        this.inspectionMessages = [];
        this.album = [];
        this.lightboxAlbum = [];
        // Get cached or create new database reference
        if (!this.inspectionMessagesCache.has(key)) {
            this.inspectionMessagesCache.set(key, listVal(ref(this.db, `inspection_messages/${key}`)));
        }
        this.allInspectionMessages = this.inspectionMessagesCache.get(key);
        this.subscribeToInspectionMessages();
    }

    removeUnreadCount(key) {
        setTimeout(() => {
            const userNotificationRef = ref(this.db, `user_notifications/${this.user.id}/${key}`);
            remove(userNotificationRef)
                .then(function() {
                    // // //
                })
                .catch(function(error) {
                    // // //
                });
        }, 0);
    }

    subscribeToInspectionMessages() {

        this.allInspectionMessages.subscribe(allInspections => {

            const object = {
                user: this.user,
                galleryOptions: this.galleryOptions,
                allInspections
            };

            this.inspectionWorker.postMessage(JSON.stringify(object));
        });
    }

    messages(data) {
        this.inspectionMessages = data.inspectionMessages;
        this.imageIndex = data.imageIndex;
        // Keep original album for display
        this.album = data.album;
        // Convert album format for lightbox
        this.lightboxAlbum = data.album.map(item => ({
            src: item.big,
            thumb: item.small,
            caption: ''
        }));
        this.imageMap = data.imageMap;
        this.shouldScroll = data.shouldScroll;
        this.spinner.hide();
        this.cdr.detectChanges();
    }

    scrollToBottom(): void {
        try {
            this.scrollDiv.nativeElement.scrollTop = this.scrollDiv.nativeElement.scrollHeight;
        } catch (err) {
            // //
        }
    }

    getDay(timestamp) {
        // The number of milliseconds in one day
        const ONE_DAY = 1000 * 60 * 60 * 24;
        const dateNow = new Date();
        const dateLast = new Date(timestamp);
        // Calculate the difference in milliseconds
        const diffTime = dateNow.getTime() - dateLast.getTime();
        const diffDays = Math.round(Math.abs((diffTime) / ONE_DAY));

        switch (diffDays) {
            case 0:
                return moment(dateLast).format('HH:mm');
            case 1:
                return 'yesterday';
            case 2:
                return moment(dateLast).format('dddd');
            case 3:
                return moment(dateLast).format('dddd');
            case 4:
                return moment(dateLast).format('dddd');
            case 5:
                return moment(dateLast).format('dddd');
            case 6:
                return moment(dateLast).format('dddd');
            case 7:
                return moment(dateLast).format('dddd');
            default:
                return moment(dateLast).format('YYYY-MM-DD');
        }
    }

    openImage() {
        this.galleryOptions = [
            {
                width: '150px',
                height: '150px',
                imageAnimation: NgxGalleryAnimation.Slide,
                thumbnails: false,
                previewZoom: true,
                previewInfinityMove: true,
                imageArrows: false,
                previewArrows: true,
                startIndex: this.imageIndex,
                previewZoomStep: 0.5,
                previewZoomMax: 10,
                imageSwipe: true,
                previewCloseOnEsc: true,
                previewKeyboardNavigation: true,
                previewRotate: true,
                previewBullets: true
            },
            // max-width 800
            {
                breakpoint: 800,
                width: '100%',
                height: '600px',
                imagePercent: 80,
            },
            // max-width 400
            {
                breakpoint: 500,
                preview: false
            }
        ];

        // this.imageIndex++;
        this.imageIndex = this.imageIndex + 1;
        this.firstLoad = false;
    }

    // close(): void {
    //   this._lightbox.close();
    // }
    private client: any;

    ngOnInit(): void {
        this.mediaPermission.subscribe(permission => {
            this.allowMic = permission;
        });


        this.galleryOptions = [
            {
                width: '150px',
                height: '150px',
                imageAnimation: NgxGalleryAnimation.Slide,
                thumbnails: false,
                previewZoom: true,
                previewInfinityMove: true,
                imageArrows: false,
                previewArrows: true,
                startIndex: 0,
                previewZoomStep: 0.5,
                previewZoomMax: 10,
                imageSwipe: true,
                previewCloseOnEsc: true,
                previewKeyboardNavigation: true,
                previewRotate: true,
                previewBullets: true
            },
            // max-width 800
            {
                breakpoint: 800,
                width: '100%',
                height: '600px',
                imagePercent: 80
            },
            // max-width 400
            {
                breakpoint: 500,
                preview: false
            }
        ];
    }
    checkRecorder(recorderStart: boolean){
        if(recorderStart){
            if(this.allowMic){
                this.startRecording();
            }else{
                this.initializeRecorder();
            }
        }else{
            this.endRecording();
        }
    }

    ngAfterViewChecked() {
        if (this.shouldScroll && this.oldInspectionMessages != this.inspectionMessages) {
            this.scrollToBottom();
            this.oldInspectionMessages = this.inspectionMessages;
        }
    }

    onSubmit() {
        if (this.activeKey !== '') {
            const message = this.messageForm.controls.message.value;
            if (message.trim() !== '') {
                this.messageForm.controls.message.setValue('');
                push(ref(this.db, `inspection_messages/${this.activeKey}/`)).then(newRef => {
                    const newKey = newRef.key;
                    const firebaseTimestamp = serverTimestamp();
                    const dateNow = moment().format('YYYY-MM-DDTHH:mm:ss');

                    const inspectionMessage = {
                        imageName: '',
                        imageUrl: '',
                        inspectionKey: this.activeKey,
                        key: newKey,
                        sender: this.user.id.toString(),
                        senderName: this.user.name + ' ' + this.user.surname,
                        text: message,
                        time: dateNow,
                        voiceName: '',
                        voiceUrl: ''
                    };

                    set(newRef, inspectionMessage);

                    const lastUpdatedRef = ref(this.db, `inspections/${this.activeKey}/lastUpdated`);
                    set(lastUpdatedRef, firebaseTimestamp);

                    this.ngOnInit();
                });
            }
        }
    }

    isEmpty(obj) {
        for (const key in obj) {
            if (obj.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }
    onFileChanged(event) {
        if (event.target.files != null) {
            const file = event.target.files[0];
            const id = uuid.v4();

            const name = file.name;
            const lastDot = name.lastIndexOf('.');
            const ext = name.substring(lastDot);
            const fileName = id + ext;

            const fileRef = storageRef(this.storage, fileName);
            uploadBytes(fileRef, file).then(result => {
                // Get URL to pass
                getDownloadURL(fileRef).then(downloadUrl => {
                    this.saveImageMessage(downloadUrl, fileName);
                    this.ngOnInit();
                });
            });
        }
    }

    saveImageMessage(downloadUrl, imageName) {
        if (this.activeKey != '') {
            if (downloadUrl != '') {
                
                push(ref(this.db, `inspection_messages/${this.activeKey}/`)).then(newRef =>  {

                    const newKey = newRef.key;
                    const firebaseTimestamp = serverTimestamp();
                    const dateNow = moment().format('YYYY-MM-DDTHH:mm:ss');

                    const inspectionMessage = {
                        imageName,
                        imageUrl: downloadUrl,
                        inspectionKey: this.activeKey,
                        key: newKey,
                        sender: this.user.id.toString(),
                        senderName: this.user.name + ' ' + this.user.surname,
                        text: '',
                        time: dateNow,
                        voiceName: '',
                        voiceUrl: ''

                    };
                    this.spinner.show();
                    set(newRef, inspectionMessage).then(r =>  this.spinner.hide());
                    const lastUpdatedRef = ref(this.db, `inspections/${this.activeKey}/lastUpdated`);
                    set(lastUpdatedRef, firebaseTimestamp).then(r =>  this.spinner.hide());

                    this.ngOnInit();
                });
            }
        }
    }


    initializeRecorder() {
        navigator.mediaDevices.getUserMedia({audio: true}).then((stream) => {
                this.mediaRecorder = new MediaRecorder(stream);
                this.mediaPermission.next(stream.active);
                if(stream.active){
                    this.startRecording();
                }
                this.mediaRecorder.onstop = e => {
                    const blob = new Blob(this.chunks, {type: 'audio/mp4; codecs=vp9'});
                    this.chunks = [];
                    const audioUrl = URL.createObjectURL(blob);

                    this.uploadAudio(blob);
                };
                this.mediaRecorder.ondataavailable = e => {
                    this.chunks.push(e.data);
                };
            },
            () => {
            //error alert
                    this.openRecorderSnackBar.open('Please visit your browser settings and allow the use of the microphone to be able to record.', 'close', {
                        duration: 10000
                    });
            },
        )
    };

    openLightbox(url): void {
        
        this._lightbox.open([{
            src: url,
            thumb: url,
            caption: ''
        }], 0);
    }

    uploadAudio(blob) {
        const fileName = uuid.v4();

        const fileRef = storageRef(this.storage, fileName);
        uploadBytes(fileRef, blob).then(result => {
            // Get URL to pass
            getDownloadURL(fileRef).then(downloadUrl => {
                this.saveAudioMessage(downloadUrl, fileName);
            });
        });
    }

    saveAudioMessage(downloadUrl, audioName) {
        if (this.activeKey != '') {
            if (downloadUrl != '') {
                push(ref(this.db, `inspection_messages/${this.activeKey}/`)).then(newRef => {
                    const newKey = newRef.key;
                    const firebaseTimestamp = serverTimestamp();
                    const dateNow = moment().format('YYYY-MM-DDTHH:mm:ss');
                    const inspectionMessage = {
                        imageName: '',
                        imageUrl: '',
                        inspectionKey: this.activeKey,
                        key: newKey,
                        sender: this.user.id.toString(),
                        senderName: this.user.name + ' ' + this.user.surname,
                        text: '',
                        time: dateNow,
                        voiceName: audioName,
                        voiceUrl: downloadUrl
                    };

                    set(newRef, inspectionMessage);
                    const lastUpdatedRef = ref(this.db, `inspections/${this.activeKey}/lastUpdated`);
                    set(lastUpdatedRef, firebaseTimestamp);

                    // this.ngOnInit();
                });
            }
        }
    }

    playAudio(type) {
        const audio = new Audio();
        audio.src = `../../../assets/audio/${type}.wav`;
        audio.load();
        audio.play();
    }


     startRecording()  {
        this.recording = true;
         // VOICE RECORDER BUTTON DELAY
         this.buttonRecordingActive = true;
         this.mediaRecorder.start();
         this.openRecorderSnackBar.open('Your recording has started, press again to send.', '', {
             duration: 2000
         });
    }
    endRecording() {
        this.playAudio('stop');
        this.mediaRecorder.stop();
        this.recording = false;
        this.buttonRecordingActive = false;
        const stopVnButton = document.querySelector('#recorder-button-stop');
        if (this.recording) {
            stopVnButton.addEventListener('mousedown', (event) => {
            });
        }

    }

    toggleInspections(width) {
        this.showInspections = !this.showInspections
        this.animationState = this.animationState === 'out' ? 'in' : 'out';
    }

    openField() {
        // this.nav.tenantId = this.tenantId;
        // this.nav.selectedTenant = this.tenantId

        // this.nav.onTenantChange();
        // this.nav.ngOnInit();

        this.farmManagementService.getFarmPolygon(this.farmId).subscribe((fields) => {
            let currectField = 0;
            let polygonHoles = [];
            let holeCounter = 0;
            let fieldCounter = 0;
            let existingPolygon: MultiPolygon;
            fields.forEach(field => {
                this.mappingService.getFieldSize(field.id).subscribe((fieldsize) => {
                    // @ts-ignore
                    const coordinates = field.boundry.features[0].geometry.coordinates;
                    const fieldPolygon = {
                        coords: coordinates,
                        fieldId: field.id,
                        fieldName: field.name
                    };
                    this.polygonCoords.push(fieldPolygon);

                    coordinates.forEach(coordinate => {
                        if (coordinate.length > 1) {
                            for (let i = 0; i < coordinate.length; i++) {
                            }
                        }
                        let polygon: google.maps.LatLngLiteral[] = [];
                        coordinate.forEach(coord => {
                            const latLngArray = coord as [];
                            if (coordinate[0][0].length > 1) {
                                polygon = [];
                            }
                            if (latLngArray.length > 2) {
                                latLngArray.forEach(latLng => {
                                    const point = {
                                        lat: Number(latLng[1]),
                                        lng: Number(latLng[0]),
                                    };

                                    polygon.push(point);
                                });
                            } else {
                                const point1 = {
                                    lat: Number(coord[1]),
                                    lng: Number(coord[0])
                                };
                                polygon.push(point1);
                            }
                            if (coordinate[0][0].length > 1) {
                                let fieldPolygon;

                                if (currectField != field.id) {
                                    currectField = field.id;
                                    polygonHoles = [];
                                    holeCounter = 0;
                                } else {
                                    holeCounter++;
                                }

                                existingPolygon = this.polygons.find(x => x.id == field.id);

                                if (existingPolygon != null) {
                                    if (holeCounter == 1) {
                                        polygonHoles.unshift(existingPolygon.points);
                                    }
                                    polygonHoles.push(polygon);
                                    fieldPolygon = {
                                        id: field.id,
                                        points: polygonHoles,
                                        size: fieldsize.size,
                                        fieldName: field.name,
                                        changed: false
                                    };
                                    this.polygons.splice(this.polygons.indexOf(existingPolygon), 1);
                                } else {
                                    fieldPolygon = {
                                        id: field.id,
                                        points: polygon,
                                        size: fieldsize.size,
                                        fieldName: field.name,
                                        changed: false
                                    };
                                }
                                this.polygons.push(fieldPolygon);
                            }
                        });

                        let fieldPolygon;

                        if (currectField != field.id) {
                            currectField = field.id;
                            polygonHoles = [];
                            holeCounter = 0;
                        } else {
                            holeCounter++;
                        }

                        existingPolygon = this.polygons.find(x => x.id == field.id);

                        if (existingPolygon != null) {
                            if (holeCounter == 1) {
                                polygonHoles.unshift(existingPolygon.points);
                            }
                            polygonHoles.push(polygon);
                            fieldPolygon = {
                                id: field.id,
                                points: polygonHoles,
                                size: fieldsize.size,
                                fieldName: field.name,
                                changed: false
                            };
                            this.polygons.splice(this.polygons.indexOf(existingPolygon), 1);
                        } else {
                            fieldPolygon = {
                                id: field.id,
                                points: polygon,
                                size: fieldsize.size,
                                fieldName: field.name,
                                changed: false
                            };
                        }
                        this.polygons.push(fieldPolygon);
                    });

                    fieldCounter++;

                    const fieldPolygons = [];
                    if (fields.length == fieldCounter) {
                        this.polygons.forEach(poly => {
                            if (poly.id == this.fieldId) {
                                fieldPolygons.push(poly.points);
                                const overlayedAnalysis = [];
                                const images = [];
                                sessionStorage.setItem('selectedTenant', this.tenantId.toString());
                                this.nav.switchTenant();
                                this.base.setAnalysis(overlayedAnalysis, images, fieldPolygons, this.polygons);
                                this.navigateField = true;
                                this.router.navigate(['/field'], { state: { id: this.fieldId, farmId: this.farmId, farmName: this.farmName, lat: this.lat, lng: this.lng, navigateField: this.navigateField, inspectionKey: this.inspectionKey, description: this.description } });
                            }
                        });
                    }
                });
            });
            this.unsortedPolygons = [];
        });
    }

    filterInspections() {
        this.openVcFilter();
    }

    openVcFilter() {
        const dialogRef = this.dialog.open(VcFilterComponent, {
            data: { tenants: this.filterTenants, startDate: this.startDate, endDate: this.endDate },
            minWidth: '30%'
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result != null) {
                this.filterTenants = result.vcFilter.tenants;
                this.startDate = result.vcFilter.startDate;
                this.endDate = result.vcFilter.endDate;
                this.applyFilter();
            }
        });
    }

    applyFilter() {
        this.subscribeToInspections();
    }

    confirmDelete(key) {
        const dialogRef = this.dialog.open(VcDeleteConfirmationComponent, {
            data: {},
            minWidth: '20%'

        });

        dialogRef.afterClosed().subscribe(result => {
            if (result != null) {
                if (result) {
                    this.deleteMessage(key);
                    this.ngOnInit();
                }
            }
        });
    }

    deleteMessage(key) {
        
        const userNotificationRef = ref(this.db, `inspection_messages/${this.activeKey}/${key}`);
        remove(userNotificationRef)
            .then(function() {
                // // //
            })
            .catch(function(error) {
                // // //
        });
    }

    onInspectionSearch(value) {
        this.selectedInspection = value;
        if (this.selectedInspection) {
            this.filteredInspections = this.filteredInspections.filter(
                item => item.description.toLowerCase().includes(this.selectedInspection.toLowerCase())
            );
        } else {
            this.filteredInspections = this.inspections;
        }
    }

    openSnackBar(message: string, action: string) {
        this._snackBar.open(message, action, {
            duration: 5000,
        });
    }
}
